import { CommonModule } from '@angular/common';
import { Component, Inject, Output, EventEmitter, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NgSelectModule } from "@ng-select/ng-select";
import { FormsModule } from '@angular/forms';
import { Api } from '../../services/api';

@Component({
  selector: 'app-mdl-change-contact',
  standalone: true,
  imports: [CommonModule, NgSelectModule, FormsModule],
  templateUrl: './mdl-change-contact.html',
  styleUrls: ['./mdl-change-contact.css']
})
export class MdlChangeContact implements OnInit {
  users: any[] = [];
  selectedOwner: string = '';
  isLoading: boolean = false;
  errorMessage: string = '';
  sendNotification: boolean = false;
  currentOwner: string = '';
  
  @Output() ownerChanged = new EventEmitter<any>();

  constructor(
    public dialogRef: MatDialogRef<MdlChangeContact>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private api: Api
  ) {
    console.log('Datos recibidos en el modal change-contact:', data);
    console.log('Contacto recibido:', data?.contacto);
    console.log('ID del contacto:', data?.contacto?.contacto_id);
  }

  ngOnInit(): void {
    this.loadUsers();
    this.setCurrentOwner();
    
    if (!this.data?.contacto) {
    console.error('No se recibieron datos del contacto', this.data);
    this.errorMessage = 'No se recibió información del contacto';
    return;
  }

  console.log('Contacto recibido:', {
    id: this.data.contacto.contacto_id,
    nombre: this.data.contacto.nombre,
    cuenta: this.data.contacto.cuenta
  });

  this.loadUsers();
  this.setCurrentOwner();
  }

setCurrentOwner(): void {
  if (!this.data.contacto) {
    console.warn('No se recibió contacto en el modal');
    this.currentOwner = 'Sin contacto';
    return;
  }

  if (!this.data.contacto.ejecutivo) {
    console.warn('El contacto no tiene ejecutivo asignado');
    this.currentOwner = 'Sin propietario asignado';
    return;
  }

  this.currentOwner = `${this.data.contacto.ejecutivo.nombre} ${this.data.contacto.ejecutivo.apellido}`;
}

loadUsers(): void {
  console.log('Cargando usuarios...');
  this.isLoading = true;
  this.api.getUsers().subscribe({
    next: (res: any) => {
      console.log('Respuesta de getUsers:', res);
      this.users = (res.users || []).map((user: any) => ({
        ...user,
        nombreCompleto: `${user.nombre} ${user.apellido}`
      }));

      console.log('Usuarios cargados:', this.users);

      // 👇 nuevo: propietario actual desde el contacto
      if (this.data.contacto?.ejecutivo_id) {
        this.selectedOwner = this.data.contacto.ejecutivo_id;
        console.log('Propietario actual seleccionado:', this.selectedOwner);
      }

      this.isLoading = false;
    },
    error: (err) => {
      console.error('Error loading users:', err);
      this.errorMessage = 'Error al cargar los usuarios';
      this.isLoading = false;
    }
  });
}


  closeModal(): void {
    console.log('Cerrando modal...');
    this.dialogRef.close();
  }

  saveChange(): void {
    console.log('Intentando guardar cambios...');
    console.log('Propietario seleccionado:', this.selectedOwner);
    console.log('ID del contacto:', this.data.contacto?.contacto_id);
    console.log('Cuenta asociada:', this.data.contacto?.cuenta);

    if (!this.selectedOwner) {
      this.errorMessage = 'Debes seleccionar un propietario';
      console.warn(this.errorMessage);
      return;
    }

    if (!this.data.contacto?.contacto_id) {
      this.errorMessage = 'Error: No se identificó el contacto correctamente';
      console.error(this.errorMessage);
      console.error('Datos del contacto:', this.data.contacto);
      return;
    }

    const currentOwnerId = this.data.contacto?.ejecutivo_id;
    console.log('ID del propietario actual:', currentOwnerId);

    if (currentOwnerId && this.selectedOwner === currentOwnerId) {
      this.errorMessage = 'Debes seleccionar un propietario diferente al actual';
      console.warn(this.errorMessage);
      return;
    }


    this.isLoading = true;
    this.errorMessage = '';

    const payload = {
      contacto_id: this.data.contacto.contacto_id,
      nuevo_propietario: this.selectedOwner,
      notificar: this.sendNotification
    };

    console.log('Enviando payload al backend:', payload);

    this.api.changeContactOwner(payload).subscribe({
      next: (res) => {
        console.log('Respuesta del backend:', res);
        this.dialogRef.close({
          success: true,
          nuevo_propietario: this.users.find(u => u.usuario_id === this.selectedOwner),
          contacto: res.contacto
        });
      },
      error: (err) => {
        console.error('Error en la respuesta del backend:', err);
        this.errorMessage = err.error?.message || 'Error al cambiar el propietario';
        this.isLoading = false;
      }
    });
  }
}